<div class="container">
  <div class="row mt-2 mb-2">
    <div class="col-sm-12">

      <tan-loader [loading]="(createProjectLoading$ | async)" [loadingText]="'<p>Creating project</p>'">
      </tan-loader>

      <div class="row justify-content-center" *ngIf="(createProjectError$ | async)">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Could not create Floor Planner project'">
          </tan-alert-message>
        </div>
      </div>

      <tan-loader [loading]="isAuthenticating" [loadingText]="'<p>Loading project</p>'">
      </tan-loader>

      <div class="row justify-content-center" *ngIf="authenticatingError">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'" [message]="'Could not open Floor Planner project'">
          </tan-alert-message>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mt-3">
          <div #floorplannerContainer class="floorplanner-embed"></div>
        </div>
      </div>

    </div>
  </div>
</div>

<tan-modal #saveConfirmation [size]="'md'" [title]="'Please confirm'" [showInformationBlock]="false"
  [hasSecondarySave]="true" [actionButtonLabel]="'Save & Edit'" [actionButtonSecondaryLabel]="'Proceed to Checkout'"
  (onSave)="closeSaveConfModal()" (onSecondarySave)="confirmUnitSizes()">
  <div modal-content>
    <div class="container">
      <div class="row">
        <div class="col-sm-12 d-flex justify-content-center">
          Would you like to continue editing your design or proceed to configuring your quote?
        </div>
      </div>
    </div>
  </div>
</tan-modal>

<tan-modal #selectUnitSize [size]="'md'" [title]="'Select size'" [showInformationBlock]="false"
  [actionButtonLabel]="'Save'"
  (onSave)="saveProject()">
  <div modal-content>
    <div class="container">
        <div class="form-group">
          <form  [formGroup]="selectForm">
            <label class="control-label" for="selectedSize">Sizes</label>
            <select class="form-control" formControlName="selectedSize" [(ngModel)]="selectedSize">
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let unitSize of unitSizes" [ngValue]="unitSize">{{ unitSize.size.size }}</option>
            </select>
        </form>
        </div>
    </div>
  </div>
</tan-modal>